if (!window.videoModalTriggerBound) {
  window.videoModalTriggerBound = true;

  window.addEventListener('click', function(event) {
    // Triggers: <a href="#id"> links, or any element (e.g. a <button>) with data-video-modal-open="id".
    var trigger = event.target.closest('a[href^="#"], [data-video-modal-open]');
    if (!trigger) {
      return;
    }

    var hash = trigger.hasAttribute('data-video-modal-open')
      ? trigger.getAttribute('data-video-modal-open')
      : trigger.getAttribute('href').slice(1);
    if (!hash) {
      return;
    }

    var template = document.querySelector('template[data-video-modal-trigger="' + CSS.escape(hash) + '"]');
    if (!template || !template.content.firstElementChild) {
      // Not one of ours — leave it for global.js's own hash handler.
      return;
    }

    event.preventDefault();

    var clone = template.content.firstElementChild.cloneNode(true);

    // Marks this item as coming from the Video Modal section specifically,
    // so photoswipe.css can scope its sizing to just this feature and leave
    // any other video content in the shared lightbox (e.g. a product's own
    // gallery video) at its default presentation.
    clone.classList.add('video-modal-media');

    if (clone.tagName.toLowerCase() === 'video' && template.dataset.videoModalMuted === 'false') {
      // Opt this element out of photoswipe.js's default forced-mute autoplay.
      clone.dataset.forceMute = 'false';
      clone.muted = false;
      clone.removeAttribute('muted');
    }

    $s.photoSwipe([clone], clone);
  });
}
